import type { Variables } from 'graphql-request';
import { useSelector } from 'react-redux';
import type { AppState } from 'src/reducers';
import { readPersonalizationSettings } from 'src/areas/user/storage/personalization';
import { useGqlQuery } from './use-gql-query';

type Options = {
  queryKey: any[];
  query: string;
  variables?: Variables;
};

export function usePersonalizedQuery<T>(options: Options) {
  const { queryKey, query } = options;

  const user = useSelector<AppState, any>(state => state.areas.user);

  const variables = {
    ...options.variables,
    pulseEnvironmentId: user?.personalization?.pulseEnvironmentId,
    personalizationClientId: user?.personalization?.clientId,
    personalizationExcludeCategories:
      readPersonalizationSettings().notInterestedIn.categories.map(
        (category: { id: string }) => +category.id
      ),
  };

  return useGqlQuery<T>({
    query,
    queryKey: queryKey.concat([variables]),
    enabled:
      !!user?.personalization?.clientId &&
      !!user?.personalization?.pulseEnvironmentId,
    variables,
  });
}
